const DEFAULT_LANGUAGE = 'pl';

const ROUTE_SLUGS = {
  es: {
    login: 'login',
    register: 'registro',
    registerVerify: 'registro/email-enviado',
    recovery: 'recuperar-password',
    home: 'datos',
    invoices: 'facturas',
    refuelings: 'repostajes',
    promotions: 'promociones',
    help: 'ayuda',
    newVehicle: 'nuevo-vehiculo',
    gasStations: 'gasolineras',
    billingData: 'datos-facturacion',
    billingNew: 'datos-facturacion/nueva-cuenta',
    billingEdit: 'datos-facturacion/editar-cuenta',
    fleetsMyFleets: 'flotas/mis-flotas',
    fleetsHistory: 'flotas/historial-pagos',
    fleetsNewVehicle: 'flotas/nuevo-vehiculo',
    fleetsAddBalance: 'flotas/agregar-saldo',
    notFound: '404',
  },
  pl: {
    login: 'logowanie',
    register: 'rejestracja',
    registerVerify: 'rejestracja/email-wyslany',
    recovery: 'odzyskaj-haslo',
    home: 'start',
    invoices: 'faktury',
    refuelings: 'tankowania',
    promotions: 'promocje',
    help: 'pomoc',
    newVehicle: 'nowy-pojazd',
    gasStations: 'stacje-paliw',
    billingData: 'dane-do-faktury',
    billingNew: 'dane-do-faktury/nowe-konto',
    billingEdit: 'dane-do-faktury/edytuj-konto',
    fleetsMyFleets: 'floty/moje-floty',
    fleetsHistory: 'floty/historia-platnosci',
    fleetsNewVehicle: 'floty/nowy-pojazd',
    fleetsAddBalance: 'floty/dodaj-saldo',
    notFound: '404',
  },
};

const ROUTE_KEYS = Object.keys(ROUTE_SLUGS.es);

const normalizePath = (pathname = '/') => {
  if (!pathname || pathname === '/') {
    return '/';
  }

  const trimmedPath = pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  return trimmedPath.startsWith('/') ? trimmedPath : `/${trimmedPath}`;
};

export const normalizeRouteLanguage = (language) => {
  const normalizedLanguage = language?.toLowerCase().split('-')[0];

  return ROUTE_SLUGS[normalizedLanguage] ? normalizedLanguage : DEFAULT_LANGUAGE;
};

export const getRoutePath = (routeKey, language = DEFAULT_LANGUAGE) => {
  const normalizedLanguage = normalizeRouteLanguage(language);
  const slug = ROUTE_SLUGS[normalizedLanguage]?.[routeKey];

  if (!slug) {
    return '/';
  }

  return `/${slug}`;
};

export const getRouteAliases = (routeKey) =>
  Object.keys(ROUTE_SLUGS)
    .map((language) => getRoutePath(routeKey, language))
    .filter(Boolean);

export const resolveRouteKey = (pathname) => {
  const normalizedPath = normalizePath(pathname);

  return (
    ROUTE_KEYS.find((routeKey) => getRouteAliases(routeKey).includes(normalizedPath)) ??
    null
  );
};

export const localizePathname = (pathname, language = DEFAULT_LANGUAGE) => {
  const routeKey = resolveRouteKey(pathname);

  if (!routeKey) {
    return normalizePath(pathname);
  }

  return getRoutePath(routeKey, language);
};

export const isRoutePath = (pathname, routeKey) => {
  const normalizedPath = normalizePath(pathname);

  if (routeKey === 'home' && normalizedPath === '/') {
    return true;
  }

  return getRouteAliases(routeKey).includes(normalizedPath);
};

export const startsWithRoutePath = (pathname, routeKey) => {
  const normalizedPath = normalizePath(pathname);

  return getRouteAliases(routeKey).some(
    (routePath) =>
      normalizedPath === routePath || normalizedPath.startsWith(`${routePath}/`),
  );
};

export const routeBelongsToGroup = (pathname, routeGroup) => {
  const routeKey = resolveRouteKey(pathname);

  return routeKey?.startsWith(routeGroup) ?? false;
};
